// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

let gallery = function(i){
    new Swiper('[data-slider="' + i + '"', {
        spaceBetween: 5,
        loop: true,
        loopedSlides: 1, //looped slides should be the same
        autoplay: {
            delay: 4000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
        observer:true,
        observeParents:true,
        observeSlideChildren:true
    });
}

gallery('#tab_0');

jQuery('.magazines a[data-toggle="tab"]').on('shown.bs.tab', function (event) {
    let tab = jQuery(event.target).attr('href');
    if(!jQuery('.swiper-container-initialized[data-slider="' + tab + '"').length){
        gallery(tab);
    }
});